export const BILLING_SETTINGS_ROUTE = 'billing_settings_index';

export const billingSettingsRoute = accountId => ({
  name: BILLING_SETTINGS_ROUTE,
  params: { accountId },
});

export const openBillingOrSuperAdmin = (router, accountId) => {
  if (router?.hasRoute?.(BILLING_SETTINGS_ROUTE)) {
    return router.push(billingSettingsRoute(accountId));
  }

  window.location.assign('/super_admin');
  return Promise.resolve();
};
